import React from 'react';

const ActionsSuiviVehicule = (): React.ReactElement => {
  // Les actions de suivi véhicule ne sont pas encore implémentées
  return <div>Actions Suivi Véhicule</div>;
};

export default ActionsSuiviVehicule;
